import { PaymentMethod } from "./payment-method";
import { CardBrand } from "./transaction";

export interface PaymentPlan {
  id: string;
  alias: string;
  comission: string;
  card_brand: CardBrand;
  has_installments: boolean;
  is_international: boolean;
  is_selected: boolean;
  payment_method: PaymentMethod;
  term: string;
}


export const planToString = (plan: PaymentPlan) => {
  const percent = parseFloat(plan.comission) * 100;

  return `Comisión de ${percent.toPrecision(3)}% a T+${plan.term}`
}
